export default __webpack_public_path__ + "static/media/home-restaurant-img-09.7351d222.jpg";